module.exports = __webpack_public_path__ + "img/service-253.219e45eb.png";